import { motion } from 'framer-motion';
import styled from 'styled-components';
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { RiTwitterXFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { Copyright } from '@mui/icons-material';

const FooterSection = styled.footer`
  background: #1c1c1c;
  padding: 4rem 2rem 2rem 2rem;
  font-family: 'Urbanist', sans-serif;
  position: relative;

  h2, h3, h4{
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;

   
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;


  .main-boxing {
    width: 100%;
    display: flex;

    @media (max-width: 768px) {
    flex-wrap: wrap;
    
    }
  }
    .inr-mnbx {
    flex: 0 0 20%;
    width: 20%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    margin-top: 30px;
    }
    }
    .nws-mnbx {
    padding-left: 70px;

    @media (max-width: 768px) {
    padding-left: 0px;
    padding-top: 30px;
    }
    }

  h2{
  font-size: 40px;
  color: #fff;
  font-weight: 500;
  padding: 0 0 30px 0;
  }

  h3{
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  padding: 0 0px 20px 0;

  @media (max-width: 768px) {
    padding: 0 0px 10px 0;
    }
  }

  a{
  font-family: 'Poppins', sans-serif;
  color: #ffffff85;
  text-decoration: unset !important;
  font-size: 15px;
  }

  p{
    color: #fff;
  }

  li {
    list-style: none;
    padding: 5px 0;
  }

  .nws-mnbx{

    p{
    margin-bottom: 20px;
    }

    button{
    background: #4F46E5;
    color: #fff;
    border-radius: 50px;
    border: 0px solid;
    width: 30%;
    padding: 15px 20px;

    @media (max-width: 768px) {
    font-size: 13px;
    width: 30%;
    padding: 4px 9px;
    }
    }

    input:focus-visible {
      border: 0px;
      outline: none;
    }

    input[type="email"] {
    border: 0px;
    width: 70%;
    font-size: 15px;
    }
    .frs-nm {
    background: #fff;
    padding: 10px 10px;
    border-radius: 50px;
   
    }
  }
`;

const StoreButtons = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;

  img {
    height: 40px;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

const SocialIcon = styled(motion.a)`
  color:rgb(0, 0, 0) !important;
  font-size: 1.5rem;
  transition: color 0.3s ease;
  background: #fff;
  padding: 12px 13px 6px 13px !important;
  border-radius: 50px;
  margin: 20px 0 0 0;
  padding-top: 20px;

  &:hover {
    color: #000;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
`;

const LegalLink = styled(Link)`
  color: #6b7280;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: #ffffff;
  }
`;

const MainCopyright = styled.div`
  display: flex;
  width: 100%;
  align-items: baseline;
  justify-content: space-between;
  border-top: 1px solid #ffffff5c;
  margin-top: 30px;

   @media (max-width: 768px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    text-align: center;
    align-items: anchor-center;
    }

  p{
    font-family: 'Poppins', sans-serif;
  }

`;

const Innercopyright = styled.div`

@media (max-width: 768px) {
   padding: 10px 0;
    }
`;

const Footer = () => {
  return (
    <FooterSection>
      <Container>
      <h2>ServTrackr</h2>

      <div class ="main-boxing">
        <div class="inr-mnbx">
          <h3>Features</h3>
          <ul>
            <li>
              <a href="/features/job-scheduling">Job Scheduling</a>
            </li>
            <li>
              <a href="/features/dispatch">Dispatch</a>
            </li>
            <li>
              <a href="/features/invoicing">Invoicing</a>
            </li>
            <li>
              <a href="/features/payments">Payments</a>
            </li>
            <li>
              <a href="/features/customer-management">Customer Management</a>
            </li>
            <li>
              <a href="/features/smart-timesheets">Smart Timesheets</a>
            </li>
            <li>
              <a href="/features/ecosystem">Business Ecosystem</a>
            </li>
          </ul>
        </div>
        <div class="inr-mnbx">
          <h3>Industries</h3>
          <ul>
            <li>
              <a href="/industries/hvac">HVAC</a>
            </li>
            <li>
              <a href="/industries/plumbing">Plumbing</a>
            </li>
            <li>
              <a href="/industries/electrical">Electrical</a>
            </li>
            <li>
              <a href="/industries/cleaning">Cleaning</a>
            </li>
            <li>
              <a href="/industries/garage-door">Garage Door</a>
            </li>
            <li>
              <a href="/industries/auto-gas">Auto Body</a>
            </li>
            <li>
              <a href="/industries/snow-removal">Snow Removal</a>
            </li>
          </ul>
        </div>
        <div class="inr-mnbx">
          <h3>Company</h3>
          <ul>
            <li>
              <a href="/company/about-us">About Us</a>
            </li>
            <li>
              <a href="/company/careers">Careers</a>
            </li>
            <li>
              <a href="/resources/blog">Blogs</a>
            </li>
            <li>
              <a href="/resources/help-center">Help Centre</a>
            </li>
            <li>
              <a href="/company/contact">Contact Us</a>
            </li>
            <li>
              <a href="/company/press">Press</a>
            </li>
          </ul>
        </div>
        <div class="nws-mnbx">
          <h3>Subscribe To Newsletter</h3>
          <p>Stay updated with the latest service tips, industry insights, and exclusive updates.</p>
          <form>
            <div class="frs-nm">
                  <input type="email" name="email" placeholder="Enter Email*" required />
                  <button type="submit">Subscribe</button>
            </div>
          </form>
          <SocialLinks>
          <SocialIcon 
            href="https://facebook.com/servtrackr" 
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaFacebook />
          </SocialIcon>
          <SocialIcon 
            href="https://x.com/servtrackr" 
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <RiTwitterXFill />
          </SocialIcon>
          <SocialIcon 
            href="https://linkedin.com/company/servtrackr" 
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaLinkedin />
          </SocialIcon>
          <SocialIcon 
            href="https://www.instagram.com/servtrackr" 
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaInstagram />
          </SocialIcon>
        </SocialLinks>
        </div>
        

      </div>

        

        
        <MainCopyright>
          <Innercopyright>
            <p>© 2025 ServTrackr</p>
          </Innercopyright>
        <LegalLinks>
          <LegalLink to="/legal/terms-of-service">Terms of Service</LegalLink>
          <LegalLink to="/legal/privacy-policy">Privacy Policy</LegalLink>
        </LegalLinks>

        </MainCopyright>
      </Container>
    </FooterSection>
  );
};

export default Footer;
